<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Tq0TbW/tc-custom/9780547561615.jpg?1734326754139" alt="This image is the cover for the book Generation Rx"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Generation Rx
      </h1>
      <p class="bookDescription body article font2">
        <b>This in-depth look at the rise of Big Pharma and pill marketing is “</b><b>a page-turner” (<i>Booklist</i>, starred review).</b><br/>  <br/> A finalist for a PEN America Literary Award for Research Nonfiction, this book takes a deep look at how the pharmaceutical industry—with some help from the medical and insurance fields and from American consumers themselves—has pushed its products, often at the expense of our health. <i>Generation Rx</i> reveals the roots of many of the widespread societal problems we face today, explaining how marketing efforts changed powerful chemical compounds for chronic diseases, once controlled by physicians, into substances we feel entitled to, whether we need them or not.<br/>  <br/> Using exclusive interviews with the strategists, scientists, and current and former heads of GlaxoSmithKline, Eli Lilly, Merck, Roche, and more, the author of <i>Fat Land</i> presents a “fascinating and disturbing” story of business interests unleashed on an unsuspecting public, and a cultural shift that has caused lasting—and sometimes lethal—damage (<i>New Scientist</i>).<br/>  <br/> “What <i>Fast Food Nation</i> did for the way Americans eat, Greg Critser does for the way we medicate ourselves.” —Michael Pollan, bestselling author of <i>The Omnivore’s Dilemma</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Greg Critser
      </h2>
      
      <p class="authorDescription body article">Greg Critser is a longtime chronicler of the modern pharmaceutical industry and the politics of medicine. His columns and essays on the subject have appeared in <I>Harper&#8217;s</I> magazine, <I>USA Today</I>, the <I>Wall Street Journal</I>, the <I>Los Angeles Times</I>, and elsewhere. Critser is the author of <I>Fat Land: How Americans Became the Fattest People in the World</I>, which the American Diabetes Association called &#8220;the definitive journalistic account of the modern obesity epidemic.&#8221; He lives in Pasadena, California, with his wife, Antoinette Mongelli.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ab70b4d0